
/**
 * este archivo es de admin
 * nomas usad el useHistorialSalidas del normal, pa traer algo de excel, que es el que genera el pdf
 */

import { Button, Spinner, Table } from "react-bootstrap";
import NavbarMio from "../components/NavbarMio";
import useSolicitudesSalida from "../hooks/useSolicitudesSalida";
import useHistorialSalidas from "../hooks/useHistorialSalidas";

export default function SolicitudesSalida() {


    const { cargando, listaHistorial, mes, setMes } = useSolicitudesSalida()
    const { traerExcel } = useHistorialSalidas({})



    const TextPermisos = () => {
        if (listaHistorial.length === 0) {
            return <p className="lead p-2">No hay historial de salidas</p>
        } else if (listaHistorial.length === 1) {
            return <p className="lead p-2">Mostrando 1 permiso</p>
        } else {
            return <p className="lead p-2">Mostrando {listaHistorial.length} permisos</p>
        }
    }


    return (
        <div className="row">
            <div className="d-flex justify-content-center mt-4 mb-5">
                <div className="col-md-8 col-12">
                    <div className="card">


                        <div className="card-header">
                            <NavbarMio ruta='solicitudes_salida' />
                        </div>


                        <div className="card-body">

                            <TextPermisos />

                            {cargando ?? <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>}

                            <div className="table-responsive col-lg-6 col-12">
                                <Table borderless>
                                    <thead>
                                        <tr>
                                            <td>Filtrar por mes</td>
                                            <td>Mostrar todos</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <input
                                                    type="month"
                                                    value={mes}
                                                    className="form-control form-control-sm"
                                                    onChange={e => setMes(e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <Button
                                                    onClick={() => setMes("todos")}
                                                    variant="link">Ver todos</Button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>



                            <div className="table-responsive">
                                <Table hover>
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Hora salida</th>
                                            <th>Empleado</th>
                                            <th>Área de adscripción</th>
                                            <th>Motivo</th>
                                            <th>Generar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listaHistorial.map(e => (
                                            <tr key={e.id}>
                                                <td>{e.fecha}</td>
                                                <td>{e.hora_salida}</td>
                                                <td>{e.nombre}</td>
                                                <td>{e.areas_adscripcion}</td>
                                                <td>{e.motivo}</td>
                                                <td>
                                                    <button className="btn btn-primary btn-block" onClick={() => traerExcel(e.id)}>
                                                        Imprimir
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
